import { readLoggedIn } from "~/utils/logInCookiesCRUD";

export default defineNuxtRouteMiddleware(() => {
  if (readLoggedIn()) return navigateTo("/");
});
